import { render, staticRenderFns } from "./DocumentSignatureLegalApproveModal.vue?vue&type=template&id=61fb4be2"
import script from "./DocumentSignatureLegalApproveModal.vue?vue&type=script&lang=js"
export * from "./DocumentSignatureLegalApproveModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports